module.exports = __webpack_public_path__ + "img/closeButt.6c1fe5f2.svg";